<template>
  <div class="page-container">
    <div class="query-title">生产计划查询&修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="材料计划抬头"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange1"
          @confirm="params => tableConfigConfirm(params, 'xTable')"
        >
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="params => rowClassName(params, 'xTable')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable')"
          >
            <template #prodpl_id="{ row }">
              <span class="blue" @click="showList(row)">{{ row.prodpl_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>

        <Table-filter
          title="材料计划明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions2.columns"
          :count-data="countFileds2"
          :all-options="allOptions2"
          :pagination="pagination2"
          @pagination-change="handleTablePaginationChange2"
          @confirm="params => tableConfigConfirm(params, 'xTable2')"
        >
          <vxe-grid
            ref="xTable2"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
            :row-class-name="params => rowClassName(params, 'xTable2')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable2')"
          >
            <template #prodpl_id="{ row }">
              <span class="blue" @click="showList(row)">{{ row.prodpl_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
  </div>
</template>

<script>
import { apiGetProdPlanList } from '@/api/sap/make-plan'
import tableMixins from '@/utils/tableMixins'
import { pageSearch, config1, config2 } from './config/makePlanQuery'
import { frontExport, exportAll } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      gridOptions2: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      // 第二个表格
      showHeader2: false,
      sortData2: [],
      tableconfigFilters2: {},
      condition2: {},
      calculation2: null,
      tableCountData2: [],
      filterList2: [],
      tableSort2: [],
      tableFilterData2: {},
      allOptions2: {},
      countFileds2: []
    }
  },
  created() {
    this.initPage(config1, 'gridOptions')
    this.initPage(config2, 'gridOptions2')
  },
  methods: {
    initPage(pageConfig, name = 'gridOptions') {
      const columns = []
      // const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120,
          filters: [],
          filterMultiple: false
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }

        columns.push(obj)
      })

      const searchKeys = Object.keys(this.pageSearch)
      searchKeys.forEach(key => {
        const keyInfo = this.pageSearch[key]
        // 验证字段是否有查询权限
        if (keyInfo.unSearchRole && this.$_has(keyInfo.unSearchRole)) {
          return
        }
        this.searchField[key] = keyInfo
      })

      this[name].columns = columns
    },
    showList({ prodpl_id, prodpl_type }) {
      if (prodpl_type === 'ZPD3') {
        this.$router.push({
          path: '/wly/make-plan/highend-check',
          query: {
            id: prodpl_id
          }
        })
      } else {
        this.$router.push({
          path: '/wly/make-plan/order-check',
          query: {
            id: prodpl_id
          }
        })
      }
    },
    async queryData(page, ranges) {
      // 分页
      if (page === 1) {
        this.pagination.page = page
        this.pagination2.page = page
        if (ranges) {
          this.ranges = ranges
          // this.handleRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        head: {
          ...this.pagination,
          ...this.condition,
          is_result: 1,
          sort: this.sortData.concat(this.tableSort)
        },
        item: {
          ...this.pagination2,
          ...this.condition2,
          is_result: 1,
          sort: this.sortData2.concat(this.tableSort2)
        },
        ...this.ranges
      }

      this.loading = true
      try {
        const { head, item } = await apiGetProdPlanList(params)
        if ((item.data.length === 0 && (item.total - 0)) || (head.data.length === 0 && (head.total - 0))) {
          this.queryData(1, ranges)
          return
        }
        // 分页
        this.pagination.totalCount = head.total - 0
        this.pagination2.totalCount = item.total - 0

        this.calculation = this.filtercalculation(head.calculation)
        this.calculation2 = this.filtercalculation(item.calculation, 'xTable2')
        // 更新计算值
        this.updateCount()
        this.updateCount('xTable2')
        // 第一个表格
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(head.data)
        } else {
          this.gridOptions.data = head.data.concat(this.tableCountData)
        }
        // 第二个表格
        if (this.showHeader2) {
          this.gridOptions2.data = this.tableCountData2.concat(item.data)
        } else {
          this.gridOptions2.data = item.data.concat(this.tableCountData2)
        }
        this.allOptions = this.filterAllOptions(head.field)
        this.allOptions2 = this.filterAllOptions(item.field, 'xTable2')
        this.setFilter()
        this.setFilter('xTable2')
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange1(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    handleTablePaginationChange2(pages) {
      Object.assign(this.pagination2, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/makePlanQuery.vue